import React from "react";
import {
  Button,
  Card as MuiCard,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { FormattedMessage } from "react-intl";

import { LottieIcon } from "src/shared/ui";
import { LottieIconNames } from "src/shared/config";
import { share } from "src/shared/utils";

type CardProps = {
  icon: LottieIconNames;
  title: React.ReactNode;
  content: React.ReactNode;
  moreClick?: () => void;
  shareContent?: string;
};

export const Card: React.FC<CardProps> = (props) => {
  const { title, icon, content, shareContent, moreClick } = props;

  const shareClick = () => {
    share(shareContent);
  };

  return (
    <MuiCard
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "rgba(255,255,255,0.2)",
      }}
    >
      <CardActionArea
        onClick={moreClick}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LottieIcon icon={icon} loop autoPlay size={100} />
        <CardContent>
          <Typography gutterBottom variant="h5" color={blueGrey[700]}>
            {title}
          </Typography>
          <Typography
            display="-webkit-box"
            maxWidth={1}
            overflow="hidden"
            textOverflow="ellipsis"
            variant="body2"
            color={blueGrey[600]}
            sx={{
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 8,
            }}
          >
            {content}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        {shareContent && (
          <Button size="small" onClick={shareClick}>
            <FormattedMessage id="productCard.share" defaultMessage="Share" />
          </Button>
        )}
        {moreClick && (
          <Button size="small" onClick={moreClick}>
            <FormattedMessage
              id="productCard.learnMore"
              defaultMessage="Learn More"
            />
          </Button>
        )}
      </CardActions>
    </MuiCard>
  );
};
